"use client";
import { Icon, IconName } from "@yardzen/ui/components/icon";
import { StyleCardToggle } from "@yardzen/ui/components/style-card-toggle";
import { ToggleCardInput } from "@yardzen/ui/components/toggle-card-input";
import Image from "next/image";

interface ResponseOption {
  text: string;
  value: string;
  icon: IconName;
  imageUrl?: string;
}

interface ResponseOptionsProps {
  options: ResponseOption[];
  responseType: "single-choice" | "multiple-choice";
  onOptionPress?: (value: string, pressed: boolean) => void;
  isSelected: (value: string) => boolean;
  register?: any;
}

export function ResponseOptions({
  options,
  responseType,
  onOptionPress,
  isSelected,
  register,
}: ResponseOptionsProps) {
  return options.map((option, index) =>
    option.imageUrl ? (
      <StyleCardToggle
        key={index}
        image={
          <Image
            src={option.imageUrl}
            alt={option.text}
            fill
            className="object-cover"
          />
        }
        className="w-[calc(50%-0.25rem)] sm:w-[calc(25%-0.375rem)]"
        value={option.value.toString()}
        responseType={responseType}
        pressed={isSelected(option.value)}
        onPressedChange={(pressed) => onOptionPress?.(option.value, pressed)}
        {...(register && { ...register })}
      />
    ) : (
      <ToggleCardInput
        key={index}
        title={option.text}
        icons={[<Icon key={option.icon} name={option.icon} size="lg" />]}
        className="w-[calc(50%-0.25rem)] sm:w-[calc(25%-0.375rem)]"
        value={option.value.toString()}
        text={option.text}
        responseType={responseType}
        onPressedChange={(pressed) => onOptionPress?.(option.value, pressed)}
        pressed={isSelected(option.value)}
        {...(register && { ...register })}
      />
    ),
  );
}
